import type { StateCreator } from 'zustand'

import type { UserDataSlice, UserStore } from '../types'

const initialState = {
  currentUser: null,
  invitations: [],
  loading: false,
  error: null,
}

export const createUserDataSlice: StateCreator<UserStore, [['zustand/immer', never]], [], UserDataSlice> = () =>
  initialState
